export default "__VITE_ASSET__b2863b9f__"